<template>
    <vue-tel-input
        :value="innerPhone"
        :only-countries="countries"
        @input="onInput"
        @validate="onValidate"
        :input-options='{"placeholder": "Írd be a telefonszámod"}'
        ref="telInput"
    />
</template>

<script>
export default {
    name: 'Phone',
    $_veeValidate: {        // ← legfelső szinten, NEM computed-ban!
        value() {
            return this.value;
        },
        name() {
            return this.$attrs['data-vv-name'];
        }
    },
    props: {
        value: [Object, String],
        countries: Array
    },
    data() {
        return {
            toJSON: undefined
        }
    },
    computed: {
        innerPhone: {
            get() {
                if (!this.value) return '';
                if (typeof this.value === 'string') return this.value;
                return this.value?.formatted || '';
            },
            set() {}
        }
    },
    mounted() {
        if (this.value && typeof this.value === 'string') {
            const phoneObject = this.$refs.telInput?.phoneObject || {};
            phoneObject.formatted = this.value;
            phoneObject.valid = false;
            phoneObject.nationalNumber = this.value.replace(/\D/g, '');
            this.$emit('input', this.sanitize(phoneObject));
        }
    },
    methods: {
        sanitize(phoneObject) {
            return {
                number: phoneObject.number ?? '',
                formatted: phoneObject.formatted ?? '',
                nationalNumber: phoneObject.nationalNumber ?? '',
                valid: phoneObject.valid ?? false,
                country: phoneObject.country
                    ? {
                        name: phoneObject.country.name,
                        iso2: phoneObject.country.iso2,
                        dialCode: phoneObject.country.dialCode,
                      }
                    : undefined,
            };
        },
        onInput(val, phoneObject) {
            this.$emit('input', this.sanitize(phoneObject));
        },
        onValidate(phoneObject) {
            this.$emit('validate', this.sanitize(phoneObject));
        }
    }
}
</script>
<style scoped>
</style>
